import React from "react";
import $ from "jquery";
import Result from "./Result";
import Loader from "../../UI/loader";
import { connect } from 'react-redux'
import { sendAnalytics } from "../../../action/homeAction"
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { getClearCredentials, validateClearVerification } from "../../../action/clearVerification";
import { setCardChecksData } from "../../../action/action";



const ClearVerificationMobile = (props) => {

    let programmaticClose = false;
    let localCardChecksData = props.cardChecksData;
    let randNum = Math.floor(Math.random() * 100000) + 1;
    const [error, setError] = React.useState(false)
    const [errorMsg, setErrorMsg] = React.useState("")
    const [showLoader, setShowLoader] = React.useState(false)
    const [enableClear, setEnableClear] = React.useState(false)
    const [askCameraPermission, setAskCameraPermission] = React.useState(false)
    const [clearCredentials, setClearCredentials] = React.useState({})
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })


    const updatedCardData = () => {
    
        if(props.cardChecksData.guestValidationMaxRetry){
            localCardChecksData.guestValidationMaxRetry = +props.cardChecksData.guestValidationMaxRetry - 1;
        }
        console.log(localCardChecksData)
        setCardChecksData(localCardChecksData)
        return true;
      }

    const handleClearResponse = (response) => {

        console.log(" Response from CLEAR " + JSON.stringify(response))

        programmaticClose = true;
        updatedCardData();
        setEnableClear(false)
        setError(false)
        setShowLoader(true)


        if (response.code) {
            try {

                validateClearVerification(response.code, props.confirmationNumber)
                    .then((res) => {

                        if (res.status == 200) {
                            setShowLoader(false)
                            props.handleCLEARData(res.data.payload)
                            props.setNextScreen();

                            props.sendAnalytics(
                                null, // as no guesdetails in logout state 
                                props.currentWidgetObj.widgetType || "Mobile Check-in",
                                "CLEAR ID VERIFICATION - SUCCESS",
                                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken") },
                                0,
                                false // guest as not logged in
                            )
                        } else {
                            setShowLoader(false)
                            setError(true)
                            setErrorMsg(res.response.data.header.status.msg)

                            props.sendAnalytics(
                                null, // as no guesdetails in logout state 
                                props.currentWidgetObj.widgetType || "Mobile Check-in",
                                "CLEAR ID VERIFICATION - FAILED",
                                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": res.response.data.header.status.msg },
                                0,
                                false // guest as not logged in
                            )
                        }
                    })
                    .catch((err) => {
                        setShowLoader(false)
                        setError(true)
                    })
            } catch (error) {
                setShowLoader(false)
                setError(true)

                props.sendAnalytics(
                    null, // as no guesdetails in logout state 
                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "CLEAR ID VERIFICATION - FAILED",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": "something went wrong in CLEAR details validation call" },
                    0,
                    false // guest as not logged in
                )
            }
        } else {
            setEnableClear(false)
            setShowLoader(false)
            setError(true)
            setErrorMsg(response.error_description)

            props.sendAnalytics(
                null, // as no guesdetails in logout state 
                props.currentWidgetObj.widgetType || "Mobile Check-in",
                "CLEAR ID VERIFICATION - FAILED",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": response.error_description },
                0,
                false // guest as not logged in
            )
        }
    }

    const getQueryParams = (url) => {
        const queryParams = {};
        const searchParams = new URLSearchParams(new URL(url).search);
        for (let [key, value] of searchParams) {
            if (queryParams[key]) {
                if (Array.isArray(queryParams[key])) {
                    queryParams[key].push(value);
                } else {
                    queryParams[key] = [queryParams[key], value];
                }
            } else {
                queryParams[key] = value;
            }
        }
        return queryParams;
    }


    const enableInAppBrowser = () => {


        let clearURL;

        if(clearCredentials.clearDemo){
            clearURL = `https://verify.partner.platform.clearme.com/?clientId=${clearCredentials.clientId}&useCase=${clearCredentials.useCase}&redirectURI=${clearCredentials.redirectURI}&state=${clearCredentials.state + "_" + randNum}&scope=${clearCredentials.scope.join('+')}`;
        } else {
            clearURL = `https://verify.clearme.com/?clientId=${clearCredentials.clientId}&useCase=${clearCredentials.useCase}&redirectURI=${clearCredentials.redirectURI}&state=${clearCredentials.state + "_" + randNum}&scope=${clearCredentials.scope.join('+')}`;
        }


        // inAppBrowserRef = window.cordova.InAppBrowser.open(
        //     `https://guest-journey.s3.amazonaws.com/static/clear.html?redirectToClear=true&clientId=${clearCredentials.clientId}&useCase=${clearCredentials.useCase}&redirectURI=${clearCredentials.redirectURI}&state=${clearCredentials.apiKey}&scope=${clearCredentials.scope.join('+')}`,
        //     '_blank',
        //     `location=yes,clearcache=yes,closebuttoncaption=Close,closebuttoncolor=${props.menuColor.assetFontColor},toolbar=yes,toolbarposition=top,toolbarcolor=${props.menuColor.backgroundColor},hidenavigationbuttons=no`
        // )


        // inAppBrowserRef.addEventListener('loadstop', function (event) {
        //     const currentUrl = event.url
        //     console.log('InAppBrowser loaded, current URL is: ' + currentUrl);

        //     const hostname = new URL(currentUrl).hostname
        //     const params = new URLSearchParams(new URL(currentUrl).searchParams)

        //     if (hostname == "guest-journey.s3.amazonaws.com") {
        //         if (params.get("code") || params.get("error")) {
        //             handleClearResponse(getQueryParams(currentUrl))
        //         }
        //     }


        //     if (currentUrl.indexOf('https://auth.partner.platform.clearme.com/error') !== -1) {
        //         inAppBrowserRef.close();
        //     }
        // });

        // inAppBrowserRef.addEventListener('loaderror', () => { setShowLoader(false); setEnableClear(false); setError(true); 
        //     props.sendAnalytics(
        //         null, // as no guesdetails in logout state 
        //         props.currentWidgetObj.widgetType || "Mobile Check-in",
        //         "CLEAR ID VERIFICATION - FAILED",
        //         { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": "error while loading inAppBrowser" },
        //         0, 
        //         false // guest as not logged in
        //     ) 
        // });

        // inAppBrowserRef.addEventListener("exit", () => { !programmaticClose && setShowLoader(false); setEnableClear(false); setError(true); 
        //     props.sendAnalytics(
        //         null, // as no guesdetails in logout state 
        //         props.currentWidgetObj.widgetType || "Mobile Check-in",
        //         "CLEAR ID VERIFICATION - CLOSED",
        //         { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": "inAppBrowser closed" },
        //         0, 
        //         false // guest as not logged in
        //     )
        // });

        if(window.device.platform == "iOS"){

            window.plugins.ASWebAuthSession.start(
                `com.innspire.${clearCredentials.state}://`,
                clearURL,
                (successRedirectUrl) => {
                    console.log("Success aswebauthenticationsession", successRedirectUrl);
                    handleClearResponse(getQueryParams(successRedirectUrl));
                }, 
                (err) => {
                    console.log("Error aswebauthenticationsession" + err);
                    setShowLoader(false);
                    setEnableClear(false);
                    setError(true);
    
                    if (!programmaticClose) {
                        props.sendAnalytics(
                            null, // as no guesdetails in logout state 
                            props.currentWidgetObj.widgetType || "Mobile Check-in",
                            "CLEAR ID VERIFICATION - CLOSED",
                            { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": "inAppBrowser closed" },
                            0,
                            false // guest as not logged in
                        )
                    }
            });
        } else {
        window.SafariViewController.isAvailable(function (available) {
            if (available) {
                window.SafariViewController.show({
                    url: clearURL,
                    hidden: false, // default false. You can use this to load cookies etc in the background (see issue #1 for details).
                    transition: 'curl', // (this only works in iOS 9.1/9.2 and lower) unless animated is false you can choose from: curl, flip, fade, slide (default)
                    dismissButton: 1,
                    tintColor: "#D3D3D3",
                    barColor: "#D3D3D3",
                    controlTintColor: "#ffffff"
                },
                    function (result) {
                        if (result.event === 'opened') {
                            setEnableClear(false);
                        } else if (result.event === 'loaded') {
                            setEnableClear(false);
                        } else if (result.event === 'closed') {
                            setShowLoader(false);
                            setEnableClear(false);
                            setError(true);

                            if (!programmaticClose) {
                                props.sendAnalytics(
                                    null, // as no guesdetails in logout state 
                                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                                    "CLEAR ID VERIFICATION - CLOSED",
                                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": "inAppBrowser closed" },
                                    0,
                                    false // guest as not logged in
                                )
                            }
                        }
                    })
            }
        })}
    }

    const successCameraPermission = () => {
        console.log("in success Camera Permission")

        setError(false)
        setShowLoader(true)

        getClearCredentials()
            .then((res) => {
                if (res.status == 200) {
                    setClearCredentials(res.data.payload)
                    setEnableClear(true)
                } else {
                    setShowLoader(false)
                    setError(true)
                    setErrorMsg(res.response.data.header.status.msg)

                    props.sendAnalytics(
                        null, // as no guesdetails in logout state 
                        props.currentWidgetObj.widgetType || "Mobile Check-in",
                        "CLEAR ID VERIFICATION - FAILED",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": res.response.data.header.status.msg },
                        0,
                        false // guest as not logged in
                    )
                }
            })
            .catch((err) => {
                setShowLoader(false)
                setError(true)
            })

    }


    React.useEffect(() => {
        if (enableClear) {
            if (Object.keys(clearCredentials).length > 0) {
                enableInAppBrowser();
            }
        }
    }, [enableClear])


    React.useEffect(() => {
        successCameraPermission()
    }, [askCameraPermission])


    window.handleOpenURL = function (url) {
        if (window.device.platform == "iOS") {
            window.SafariViewController.hide();
        }
        handleClearResponse(getQueryParams(url));
    };


    return (
        <div className="clear-container" >
            {enableClear ? null :
                showLoader ? <Loader close={() => this.setState({ showLoader: false })} displayMsg="Fetching Data..." /> :
                    error ? <Result backBtn={props.goBack} tryAgain={() => { setAskCameraPermission(!askCameraPermission) }} heading="Mobile Check-in" page="clear" success={false}
                    ga_error_message={localCardChecksData.guestValidationMaxRetry == 0 ? errorMsg ? errorMsg : "Something Went Wrong" : errorMsg ? errorMsg + " Please contact Front Desk or try again." : "Something Went Wrong. Please contact Front Desk or try again."}
                    message={localCardChecksData.guestValidationMaxRetry == 0 ? errorMsg ? errorMsg : "Something Went Wrong" : errorMsg ? errorMsg + " Please contact Front Desk or try again." : "Something Went Wrong. Please contact Front Desk or try again."} />
                    : null}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        currentHomePage: state.store2.currentHomePage,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        cardChecksData: state.store2.cardChecksData,
    }
}

export default connect(mapStateToProps, { setCardChecksData, sendAnalytics })(ClearVerificationMobile);